module.exports = __webpack_public_path__ + "assets/retina_TriangleByMidpointsDetailed.8942aea9d8e59898673fca08aa4531b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TriangleByMidpointsDetailed.png
// module id = 749
// module chunks = 0